import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { productApi, type HealthSnapshot, type ScoreSnapshot } from '../../api/products';

export function ProductHealthPage() {
  const { id = '' } = useParams();
  const [health, setHealth] = useState<HealthSnapshot | null>(null);
  const [score, setScore] = useState<ScoreSnapshot | null>(null);

  useEffect(() => {
    void Promise.all([productApi.health(id), productApi.score(id)]).then(([h, s]) => {
      setHealth(h);
      setScore(s);
    });
  }, [id]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to={`/products/${id}`} className="text-sm text-slate-600 hover:underline">← Product</Link>
      <h1 className="mt-4 text-2xl font-semibold">Health & Quality</h1>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border bg-white p-4">
          <p className="text-sm text-slate-500">Health score</p>
          <p className="text-2xl font-semibold">{health?.score ?? '—'}</p>
          <p className="text-sm capitalize text-slate-600">{health?.status}</p>
          {health?.issues?.length ? <ul className="mt-2 text-xs text-amber-700">{health.issues.map((i) => <li key={i}>{i}</li>)}</ul> : null}
        </div>
        <div className="rounded-xl border bg-white p-4">
          <p className="text-sm text-slate-500">Overall quality score</p>
          <p className="text-2xl font-semibold">{score?.overall_score ?? '—'}</p>
          <p className="mt-2 text-xs text-slate-600">Completeness {score?.completeness_score} · Quality {score?.quality_score}</p>
          {score?.missing_fields?.length ? <p className="mt-2 text-xs text-slate-500">Missing: {score.missing_fields.join(', ')}</p> : null}
        </div>
      </div>
    </div>
  );
}
